/**
 * Confirmation Block Renderer
 * Renders binary choice dialogs (Yes/No, Confirm/Cancel, etc.)
 */

import React from "react";
import { Confirmation } from "@strivelabs/ui-blocks";
import type { UIBlock, UIActionEvent } from "@/types/ui-blocks";

export interface ConfirmationBlockRendererProps {
  block: UIBlock;
  onUIAction: (event: UIActionEvent) => void;
  /** When true, the component is disabled */
  readOnly?: boolean;
}

export function ConfirmationBlockRenderer({
  block, 
  onUIAction,
  readOnly = false
}: ConfirmationBlockRendererProps) {
  const [disabled, setDisabled] = React.useState(readOnly);
  if (block.type !== 'confirmation') return null;
  const { content } = block;

  const handleAction = (action: { label: string; value: string }) => {
    if (disabled) return;

    // Emit UI action event back to the chat system
    onUIAction({
      type: "ui_action",
      component: "confirmation",
      label: content.label,
      state: { action, confirmed: true }
    });
    
    setDisabled(true);
  };

  return (
    <Confirmation
      label={content.label}
      description={content.description}
      confirmAction={content.confirmAction}
      cancelAction={content.cancelAction}
      onAction={handleAction}
      disabled={disabled}
    />
  );
}
